import React, { useMemo, useState, useEffect, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { CartContext } from "../util/cartContext";
import { AgeVerificationContext } from "../util/AgeVerificationContext";
import { fetchProducts } from "../dataSource/ProductSource";
import { useSearchParams } from "react-router-dom";
import "./styling/productPage.css";
import "./styling/webshopSati.css";
import "./styling/productPage-s.css";
import logoSatiata from "./assets/logoSatiata.svg";
import cartImg from "./assets/cartWhite.svg";
import FilterBar from "../components/FilterBar";
import SortBar from "../components/SortBar";
import useProductFilters from "../util/UseProductFilters";
import bgLogo from "./assets/satiataLogo.jpg";



const WebshopSati = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

   const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  const { cart, addToCart, removeFromCart, totalPrice, cartMessage, cartMessageType } =
    useContext(CartContext);

  const { isOver18, setIsOver18 } = useContext(AgeVerificationContext);
  
  const [isMobile, setIsMobile] = useState(
    window.matchMedia("(max-width: 1200px)").matches
  );

  const [dynamicProducts, setDynamicProducts] = useState([]); 
  const [quantities, setQuantities] = useState({}); 
  const [feedbackMessages, setFeedbackMessages] = useState({}); 

    const { filters, setFilters, filteredProducts, facets, priceBounds, inhoudBounds } =
  useProductFilters(dynamicProducts, { syncUrl: true });


  const routeMap = {
    1: "limoncello",
    2: "valenti",
    3: "yuzu",
    4: "yuzugin",
    5: "sanpellegrino"
  };

  useEffect(() => {
    const loadProducts = async () => {
      const data = await fetchProducts();
      setDynamicProducts(data);
    };
    loadProducts();
  }, []);

  const addProductToCart = (product) => {

    const quantity = quantities[product.id] || 1;
  
    // Prevent adding if stock is already in cart
    const cartItem = cart.find((item) => item.id === product.id);

    if (cartItem && cartItem.quantity >= (product.product_info?.stock ?? 20)) {      

      setFeedbackMessages((prev) => ({
        ...prev,
        [product.id]: "Maximaal aantal (" + (product.product_info?.stock !== null ? product.product_info.stock : 20) + ") bereikt."

      }));
      return;
    }
  
    addToCart(product, quantity);
  
    setFeedbackMessages((prev) => ({
      ...prev,
      [product.id]: "Item(s) toegevoegd aan mandje!",
    }));
  
    setTimeout(() => {
      setFeedbackMessages((prev) => ({ ...prev, [product.id]: "" }));
    }, 5000);
  };
  
  const handleQuantityChange = (productId, value) => {
    if (isNaN(value) || value < 1) return; 
  
    setQuantities((prevQuantities) => ({
      ...prevQuantities,
      [productId]: value, 
    }));
  };
  

  return (
    <>
      {!isOver18 && (
        <div id="ageWrapper">
          <div id="ageBox" className="satiAgeBox">

            <div id="ageLogoWrapper">
              <img src={logoSatiata} alt=""></img>
            </div>

            <h1>Ben je 18 jaar of ouder?</h1>

            <div id="ageButtons">

              <button className="checkout-btn yes-btn" onClick={() => setIsOver18(true)}>Ja</button>
              <Link
                to="/"
              >
              <button className="checkout-btn">Nee</button>
              </Link>

            </div>
          </div>
        </div>
      )}
      {!isMobile && <div className="desktopNavSpacer"></div>}
      <div className="shopPromo shopPromoSati">
      <div>
      <i class="bi bi-truck"></i>
      <strong>Gratis bezorging bij bestellingen vanaf €100</strong>
      </div>
      <div>
      <i class="bi bi-shop-window"></i>
      <strong>Bestel online & ophalen in de winkel (gratis)</strong>
      </div>      
      </div>
      
      <div id="WebshopSati">
        <div id="productBox">
          <div id="productBoxWrapper">
           
            <div className="productBoxTitle">
              <img src={logoSatiata} alt="Pulcinos Logo"></img>

              <h1>Webshop</h1>
              {/* <span>Likeuren</span> */}
              <div className="vine"></div>
            </div>

            <div className="webshopIntro">
                <h2>Ontdek ons aanbod</h2>
                 <p>
                    Bij <strong>Satiata</strong> vindt u een zorgvuldig samengestelde collectie natuurwijnen van kleine producenten. 
                    Wijnen met een duidelijke herkomst en minimale interventie, geselecteerd op zuiverheid, balans en karakter. 
                    Ons aanbod wisselt mee met de oogst en beschikbaarheid, zodat u steeds iets vers en eigens ontdekt. 
                    Neem rustig de tijd om te bladeren en vind de fles die bij uw moment past.
                </p>
               
            </div>             

            <div className="webshopSection">               

            <div className="filtersWrapper">

                <FilterBar
                filters={filters}
                setFilters={setFilters}
                priceBounds={priceBounds}
                inhoudBounds={inhoudBounds}   
                facets={facets}            
                />

            </div>

            {filteredProducts && (
            <div id="productContainer">

            <img className="bgLogo" src={bgLogo} alt=""></img>

            <SortBar
                value={filters.sort}
                onChange={(sort) => setFilters(f => ({ ...f, sort }))}
                total={filteredProducts.length}
            />

            
            {filteredProducts.map((product) => (
                <div data-aos="fade-up" className="product" key={product.id}>
                  <div className="productImageWrapper">
                    <img
                      src={product.images?.length > 0 ? product.images[0].image_url : "https://via.placeholder.com/150"}
                      alt={product.name}
                    />
                  </div>

                  <div className="productInfo">
                    {!isMobile ? (
                      <h2 className="productTitle">
                        <span className="satiataRed">{product.name}</span> - €{product.price.toFixed(2)}
                      </h2>
                    ) : (
                      <h2 className="productTitle">
                        <span className="satiataRed">{product.name}&nbsp;</span>
                        <span>€{product.price.toFixed(2)}</span>
                      </h2>
                    )}

                    <span className="productInfoSpan">{product.summary || "Geen beschrijving beschikbaar."}</span>

                    <div className="productButtons">
                    <Link
                      className="hightlightsLink"
                      to={`/webshop/${routeMap[product.id] || product.id}`}
                      style={{ textDecoration: "none" }}
                    >
                      {!isMobile ? <button>Bekijk product</button> : <button>Bekijk</button>}
                    </Link>

                      <input
                        type="number"
                        id="quantity"
                        value={quantities[product.id] || 1}
                        name={`quantity_${product.id}`}
                        max={product.product_info?.stock !== null ? product.product_info.stock : 20}
                        onChange={(e) => handleQuantityChange(product.id, parseInt(e.target.value, 10))}
                      />

                      <button className="add-to-cart" onClick={() => addProductToCart(product)}>
                        <img src={cartImg} alt="+" />
                      </button>
                    </div>

                    {feedbackMessages[product.id] && (
                      <div className="cart-feedback">{feedbackMessages[product.id]}</div>
                    )}
                  </div>
                </div>
              ))}
            
            </div>
            )}

            </div>

            <div></div>
          </div>
        </div>
      <div className="vine vineBottom"></div>
      </div>
    </>
  );
};

export default WebshopSati;
